import {Component, OnInit} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import { AuthenticationService } from '../../services/authentication/authentication.service';
import {MenusModule} from "@progress/kendo-angular-menu";
import {Router} from "@angular/router";
import {TranslatorComponent} from "../../shared/components/translator/translator.component";
import { TranslatePipe } from '@ngx-translate/core';
import { take, tap } from 'rxjs';
import { AfRoutes } from '../../routes';

@Component({
  selector: 'af-dropdowns',
  imports: [
    AsyncPipe,
    MenusModule,
    TranslatorComponent,
    TranslatePipe
  ],
  templateUrl: './dropdowns.component.html',
  styleUrl: './dropdowns.component.scss'
})
export class DropdownsComponent implements OnInit {

  protected oidcEnabled: boolean | undefined = undefined;

  constructor(
    public authenticationService: AuthenticationService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.authenticationService
      .isOidcEnabled()
      .pipe(
        tap((enabled) => {
          this.oidcEnabled = enabled;
        }),
        take(1)
      )
      .subscribe();
  }

  async onSelect(e: any) {
    const action = e?.item?.data?.action;

    if (action === 'logout') {
      await this.router.navigate([AfRoutes.signOut]);
    }
  }
}
